import { render } from "./ForYou.vue?vue&type=template&id=b99c9c5c&scoped=true"
import script from "./ForYou.vue?vue&type=script&lang=js"
export * from "./ForYou.vue?vue&type=script&lang=js"

import "./ForYou.vue?vue&type=style&index=0&id=b99c9c5c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b99c9c5c"]])

export default __exports__